<template>

	<div>
		<!-- 添加弹出框 -->
		<el-dialog title="编辑角色" :visible.sync="show" width="70%" top="2vh" :before-close="handleDialogClose"
			:close-on-click-modal="false">
			<div style="height: 72vh ;overflow-y: auto;">
				<el-form :model="submit_data" ref="myForm" label-width="70px">
					<el-form-item label="角色名称" class="formName">
						<el-input v-model="submit_data.name"></el-input>
					</el-form-item>




					<el-form-item label="权限选择" label-width="90px">

						<el-checkbox-group v-model="array" v-for="(v,k) in check_lists">

							<!-- 一级菜单 -->
							<el-checkbox :label="v.pass_action" :ref="v.pass_action" :data="v" v-if="v.name"
								@change="checkChange(v.pass_action,'1')">

								{{v.name}}


							</el-checkbox>

							<el-form-item></el-form-item>


							<el-checkbox-group v-model="array" v-for="(v1,k1) in v.sup_array"
								style="margin-left: 2%;margin-top: -1%;">

								<!-- 二级菜单 -->
								<el-checkbox :label="v1.pass_action" :ref="v1.pass_action" :data="v1" v-if="v1.name"
									@change="checkChange(v1.pass_action,'2',v.pass_action)">

									{{v1.name}}


								</el-checkbox>

								<el-form-item></el-form-item>


								<el-checkbox-group v-model="array" style="margin-left: 2%;margin-top: -1%;">



									<!-- 三级菜单 -->
									<el-checkbox v-for="(v2,k2) in v1.sup_array" :label="v2.pass_action" :ref="v2.pass_action" :data="v2"
										v-if="v2.name" @change="checkChange(v2.pass_action,'3',v.pass_action,v1.pass_action)">

										{{v2.name}}


									</el-checkbox>




									<el-form-item></el-form-item>

								</el-checkbox-group>


							</el-checkbox-group>


						</el-checkbox-group>


					</el-form-item>

					<el-form-item label="指派模式" label-width="90px">
						<el-checkbox-group v-model="assign_mode_submit">
							<el-checkbox v-for="(item, index) in assign_mode_array" :label="index">

								{{item.alias}}

							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<el-form-item label="司机充值权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_wallet_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="续费签约权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_sign_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="司机标记权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_write_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="乘客充值权限:" label-width="150px">
						<el-switch v-model="submit_data.consumer_recharge_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="司机账面分权限:" label-width="150px">
						<el-switch v-model="submit_data.driver_driverpoints_add" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="订单发票导出:" label-width="150px">
						<el-switch v-model="submit_data.export_order_invoice" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="银行卡导出:" label-width="150px">
						<el-switch v-model="submit_data.export_bank_card" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>

					<el-form-item label="司机在线时长导出:" label-width="150px">
						<el-switch v-model="submit_data.export_order_count" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>



					<el-form-item label="定位红包:" label-width="150px">
						<el-switch v-model="submit_data.positioning_reward" active-value="1" inactive-value="0"></el-switch>
					</el-form-item>


					<el-form-item label="角色备注">
						<el-input type="textarea" rows="5" v-model="submit_data.remarks"></el-input>
					</el-form-item>


				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleDialogClose">取消</el-button>
				<el-button type="primary" @click="editRoleSubmit">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
	var _this;
	export default {
		created() {

			_this = this;

		},

		// 接受父组件传的值
		props: {

			isShow: true,

			editRole_data: ''

		},
		// 监听父组件传过来的值
		watch: {

			isShow(newData, oldData) {

				_this.show = true;

				_this.$post(
					"/system/getRoleDetails", {
						admin_role_code: _this.editRole_data
					}).then(res => {

					_this.submit_data.admin_role_code = res.data.admin_role_code


					_this.submit_data.name = res.data.name;

					_this.submit_data.remarks = res.data.remarks;

					_this.submit_data.driver_wallet_add = res.data.driver_wallet_add;
					_this.submit_data.driver_sign_add = res.data.driver_sign_add;
					_this.submit_data.driver_write_add = res.data.driver_write_add;
					_this.submit_data.consumer_recharge_add = res.data.consumer_recharge_add;
					_this.submit_data.driver_driverpoints_add = res.data.driver_driverpoints_add;

					_this.submit_data.export_order_invoice = res.data.export_order_invoice;
					_this.submit_data.export_bank_card = res.data.export_bank_card;
					_this.submit_data.export_order_count = res.data.export_order_count;

					_this.submit_data.positioning_reward = res.data.positioning_reward;
					_this.assign_mode_array = res.data.assign_mode
					_this.array = JSON.parse(res.data.synchronization);

					for (const key in res.data.assign_mode) {
						if (res.data.assign_mode[key].checked) {

							_this.assign_mode_submit.push(key)

						}
					}

					console.log(_this.array);


				})

				_this.adminClassLists();

			},

		},
		data() {

			return {
				array: [],
				show: false,
				search_data: {},
				check_lists: {},
				assign_mode_array: {},

				assign_mode_submit:[],


				cityList: [],

				submit_data: {
					admin_role_code: '',
					name: '',
					synchronization: [],
					remarks: '',
					assign_mode:'',
					driver_wallet_add:'0',
					driver_sign_add:'0',
					driver_write_add:'0',
					consumer_recharge_add:'0',
					driver_driverpoints_add:'0',
					export_order_invoice:'0',
					export_bank_card:'0',
					export_order_count:'0',
					positioning_reward:'0'
				},
				submit_rules: {
					name: {
						placeholder: '角色名',
						rules: {
							required: true,
							message: '角色名10个汉字以下',
							regulation: 'elt_str',
							rulesData: 30
						}
					},
					synchronization: {
						placeholder: '权限模块',
						rules: {
							required: false,
							message: '权限模块代码数组(json)',
							regulation: 'special',
							rulesData: 'json_array'
						}
					},
					remarks: {
						placeholder: '角色备注',
						rules: {
							required: false,
							message: '角色备注说明，200字节以内',
							regulation: 'lt_str',
							rulesData: 200
						}
					}
				},
			}
		},
		methods: {



			handleDialogClose() {

				_this.show = false;
				_this.assign_mode_submit = [];
				_this.array = [];
				_this.submit_data = {
					admin_role_code: '',
					name: '',
					synchronization: [],
					remarks: '',
					assign_mode:'',
					driver_wallet_add:'0',
					driver_sign_add:'0',
					driver_write_add:'0',
					consumer_recharge_add:'0',
					driver_driverpoints_add:'0',
					export_order_invoice:'0',
					export_bank_card:'0',
					export_order_count:'0',
					positioning_reward:'0'
				}


			},

			arrayDel(data) {
				for (let delindex = 0; delindex < _this.array.length; delindex++) {

					// 如果数组中存在需要删除的数据则删除
					if (_this.array[delindex] == data) {
						_this.array.splice(delindex, 1);
					}

				}
			},

			checkChange(e, level, firParent, secParent) {

				// switch (level) {
				// 	case '1':


				// 		// 如果点击的一级元素被选中
				// 		if (!(_this.$refs[e][0].isChecked)) {

				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				// 将对应的二级选中
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					_this.array.push(_this.$refs[e][0].$attrs.data.sup_array[i].pass_action)

				// 					// 数组去重
				// 					_this.array = [...new Set(_this.array)];

				// 					if (_this.$refs[e][0].$attrs.data.sup_array[i].sup_array) {

				// 						// 将对应的三级选中
				// 						for (let j = 0; j < _this.$refs[e][0].$attrs.data.sup_array[i].sup_array.length; j++) {

				// 							_this.array.push(_this.$refs[e][0].$attrs.data.sup_array[i].sup_array[j].pass_action)

				// 							// 数组去重
				// 							_this.array = [...new Set(_this.array)];
				// 						}

				// 					}


				// 				}

				// 			}



				// 		} else {

				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				// 遍历得到二级pass_action属性
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					// 需要在array中删除的数据
				// 					var delData2 = _this.$refs[e][0].$attrs.data.sup_array[i].pass_action;

				// 					_this.arrayDel(delData2);

				// 					if (_this.$refs[e][0].$attrs.data.sup_array[i].sup_array) {

				// 						// 遍历得到三级pass_action属性
				// 						for (let j = 0; j < _this.$refs[e][0].$attrs.data.sup_array[i].sup_array.length; j++) {

				// 							var delData3 = _this.$refs[e][0].$attrs.data.sup_array[i].sup_array[j].pass_action;

				// 							_this.arrayDel(delData3);

				// 						}

				// 					}



				// 				}

				// 			}



				// 		}

				// 		break;
				// 	case '2':

				// 		// 如果点击的二级元素被选中
				// 		if (!(_this.$refs[e][0].isChecked)) {

				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				// 将对应的三级选中
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					_this.array.push(_this.$refs[e][0].$attrs.data.sup_array[i].pass_action)

				// 					// 数组去重
				// 					_this.array = [...new Set(_this.array)];

				// 				}

				// 			}


				// 			// 将对应的一级选中
				// 			_this.array.push(firParent);

				// 			// 数组去重
				// 			_this.array = [...new Set(_this.array)];

				// 		} else {

				// 			if (_this.$refs[e][0].$attrs.data.sup_array) {

				// 				// 遍历得到三级pass_action属性
				// 				for (let i = 0; i < _this.$refs[e][0].$attrs.data.sup_array.length; i++) {

				// 					// 需要在array中删除的数据
				// 					var delData3 = _this.$refs[e][0].$attrs.data.sup_array[i].pass_action;

				// 					_this.arrayDel(delData3);

				// 				}

				// 			}



				// 		}

				// 		break;
				// 	case '3':



				// 		// 如果点击的三级元素被选中
				// 		if (!(_this.$refs[e][0].isChecked)) {

				// 			// 将对应的一级选中
				// 			_this.array.push(firParent);

				// 			// 数组去重
				// 			_this.array = [...new Set(_this.array)];

				// 			// 将对应的二级选中
				// 			_this.array.push(secParent);

				// 			// 数组去重
				// 			_this.array = [...new Set(_this.array)];

				// 		}



				// 		break;
				// 	default:
				// 		break;
				// }


			},


			//初始化权限列表
			adminClassLists() {
				_this.$post(
					"/system/passAction",
					_this.search_data
				).then(res => {

					_this.check_lists = {};

					_this.check_lists = res.data;


				})

			},
			// 添加角色
			editRoleSubmit() {

				_this.submit_data.assign_mode = JSON.stringify(_this.assign_mode_submit)
				console.log(_this.array);

				//json格式化
				_this.submit_data.synchronization = JSON.stringify(_this.array);

				_this.$post(
					"/system/editRoleSubmit",
					_this.submit_data,
					_this.submit_rules
				).then(res => {

					_this.handleDialogClose();

					_this.$message.success("编辑" + res.msg);

					var return_data = {
						page: 1,
						limit: 10,
						name: ''
					};

					//刷新
					_this.$emit("submit_ok_return", return_data);

				})


			}

		}
	}
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.formName {
		margin-left: 20px;
	}
</style>
